// extracted by mini-css-extract-plugin
module.exports = {"close":"ConnectModal_close__u1MS7","header":"ConnectModal_header__Mtpxm"};